import { Menu } from "antd";

import {
  CreditCardOutlined,
  LogoutOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import UpdateProfile from "../../../pages/admin/User/UpdateProfile";
import { useCallback, useMemo, useState } from "react";
import ChangePassword from "../../../pages/admin/User/ChangePassword";
import httpClient from "../../../api/httpClient";
import { parseError } from "../../../utils/shared";
import { ROUTES } from "../../../constant/routes";
import { useNavigate } from "react-router-dom";
import {
  selectSelectedTenant,
  selectUserState,
} from "../../../store/user/selectors";
import { useSelector } from "react-redux";
import Avatar from "../../generic/Avatar";

const MoreMenu = () => {
  const { user } = useSelector(selectUserState);
  const selectedTenant = useSelector(selectSelectedTenant);
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const onLogout = useCallback(async () => {
    try {
      setSubmitting(true);

      await httpClient.post("logout", {
        refresh_token: httpClient.getRefreshToken(),
      });
    } catch (error) {
      parseError(error, true);
    } finally {
      setSubmitting(false);

      localStorage.clear();
      window.location.href = ROUTES.SIGNIN;
    }
  }, []);

  const moreItems = useMemo(
    () => [
      {
        key: "more",
        icon: <Avatar user={user} size={38} className="cursor-pointer more-icon" />,
        label: "More",
        children: [
          {
            key: "profile",
            label: <UpdateProfile />,
          },
          {
            key: "changePassword",
            label: <ChangePassword />,
          },
          ...(selectedTenant?.role === "OWNER"
            ? [
                {
                  key: "billing",
                  icon: <CreditCardOutlined />,
                  label: "Billing",
                  onClick: () =>
                    navigate(
                      `${ROUTES.BILLING}?tenant_id=${selectedTenant?.id}`,
                    ),
                },
              ]
            : []),
          {
            key: "settings",
            icon: <SettingOutlined />,
            label: "Settings",
            onClick: () => navigate(ROUTES.BUSINESS),
          },
          {
            type: "divider",
          },
          {
            key: "logout",
            icon: <LogoutOutlined />,
            label: "Logout",
            disabled: submitting,
            danger: true,
            onClick: onLogout,
          },
        ],
      },
    ],
    [user],
  );

  return (
    <Menu
      mode="inline"
      className="more-menu"
      items={moreItems}
      selectedKeys={[]}
    />
  );
};

export default MoreMenu;
